import styled from "styled-components";

export const TravellerCont = styled.div`
  padding: 2.5rem 3rem;
  border-top: 0.1rem #e5edf6 solid;
  .fieldRow {
    margin-bottom: 2.2rem;
    max-width: 334px;
  }
  .labelText {
    display: block;
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: #141823;
    margin-bottom: 1rem;
  }
  .guestDtls__contact {
    flex-shrink: 0;
    position: relative;
    margin-right: -0.3rem;
  }
  .frmSelectCont__contact {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .frmSelect {
    width: 100%;
    height: 100%;
    outline: 0;
    border: 0;
  }
  .selectedCode {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    height: 3.5rem;
    min-width: 7rem;
    max-width: 9rem;
    background-color: #eef4fd;
    border: 0.1rem #e5edf6 solid;
    border-radius: 0.4rem 0 0 0.4rem;
    padding: 0 2.5rem 0 1rem;
    font-size: 1.4rem;
    color: #141823;
    position: relative;
    overflow: hidden;
    pointer-events: none;
    transition: all 0.3s linear;
  }
  .selectedCode::after {
    position: absolute;
    right: 0.8rem;
    top: 1.3rem;
    border: solid #898b91;
    border-width: 0 0.2rem 0.2rem 0;
    display: inline-block;
    padding: 0.2rem;
    transform: rotate(45deg);
    content: "";
    pointer-events: none;
  }
`;

export const ErrorToastTxt = styled.p(
  (props) => `
  font-family: ${props.theme.font.fontFamily};
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
	color: #ff3a5c;
	margin: 0.3rem 0rem 0rem 0.3em;
`
);

export const GenderWidget = styled.div`
  width: 8rem;
  height: 3.5rem;
  padding: 0.6rem 0.8rem;
  margin: 0rem 1rem 0rem 0rem;
  border: 0.1rem #e5edf6 solid;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  color: #141823;
  outline: 0;
`;

export const InputFlex = styled.div`
  width: 100%;
  height: 3.5rem;
  padding: 0.6rem 1rem;
  border: 0.1rem #e5edf6 solid;
  border-radius: 0.4rem;

  font-size: 1.4rem;
  color: #141823;
  outline: 0;
`;
